import { retryQueryOnInternalServerError } from "app/pages/sales-intelligence/query/utils";

import { LEAD_GENERATOR_THREAD_QUERY_OPTIONS } from "../../../../queries/const";
import { aiAgentQueryKeys } from "../../../../queries/queryKeyFactory";
import { BasePrefetchThreadService } from "../../../../services/thread/basePrefetchThreadService";
import type { IPrefetchThreadServiceDependencies } from "../../../../services/thread/basePrefetchThreadService";

import leadGeneratorThreadService from "./threadService.init";
import type { ILeadGeneratorThreadPrefetchService, ThreadOptions } from "./types";

/**
 * Service for prefetching lead generator agent threads
 */
class LeadGeneratorThreadPrefetchService
    extends BasePrefetchThreadService
    implements ILeadGeneratorThreadPrefetchService
{
    private static instance: LeadGeneratorThreadPrefetchService | null = null;

    static initialize(dependencies: IPrefetchThreadServiceDependencies): LeadGeneratorThreadPrefetchService {
        if (!LeadGeneratorThreadPrefetchService.instance) {
            LeadGeneratorThreadPrefetchService.instance = new LeadGeneratorThreadPrefetchService(dependencies);
        }

        return LeadGeneratorThreadPrefetchService.instance;
    }

    /**
     * Prefetches a thread, fire-and-forget behavior
     */
    private async prefetchThreadInternal(options?: ThreadOptions): Promise<void> {
        const queryKey = aiAgentQueryKeys.leadGenerator.thread(options?.savedSearchId);

        return this.queryClient.prefetchQuery({
            queryKey,
            ...LEAD_GENERATOR_THREAD_QUERY_OPTIONS,
            retry: retryQueryOnInternalServerError,
            queryFn: () => leadGeneratorThreadService.createThread(),
        });
    }

    async prefetchThread(options?: ThreadOptions): Promise<void> {
        if (!leadGeneratorThreadService.isFeatureEnabled()) {
            return;
        }

        return this.prefetchThreadInternal(options);
    }
}

export default LeadGeneratorThreadPrefetchService;
